import { useEffect, useState } from "react";

/**
 * Hook to detect if the Mix Chrome extension is installed
 * @returns boolean indicating if extension is installed, or null if still checking
 */
export function useExtensionInstalled(): boolean | null {
    const [isInstalled, setIsInstalled] = useState<boolean | null>(null);

    useEffect(() => {
        async function checkExtensionInstalled() {
            // Extension IDs to check
            const extensionIds = [
                "lmbbnpelmllcplpeelhghdbjjgcdickc", // Production (Chrome Web Store)
                "pjodaciajdicmnialbfcekikmkbjlknf" // Local development
            ];

            // Check each extension ID
            for (const extensionId of extensionIds) {
                try {
                    const res = await fetch(
                        `chrome-extension://${extensionId}/ping.html`,
                        {
                            method: "GET"
                        }
                    );

                    // If the fetch succeeds → extension is installed
                    if (res.ok) {
                        setIsInstalled(true);
                        return;
                    }
                } catch (err) {
                    // Try next extension ID
                    continue;
                }
            }

            // None of the extensions found
            setIsInstalled(false);
        }

        checkExtensionInstalled();
    }, []);

    return isInstalled;
}
